(function () {
  'use strict';
  var script = document.currentScript;
  if (!script || window.BinamSales) return;
  var environment = script.dataset.environment || 'dev';
  var themeId = script.dataset.themeId;
  var cartUrl = script.dataset.cartUrl;
  var cartPage = script.dataset.cartPage;
  var measurementId = script.dataset.measurementId;
  var configured = false;
  var queue = [];
  var pending = [];
  function send(entry) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') { pending.push(entry); if(pending.length>100)pending.shift(); return; }
    if (!privacy.analyticsProcessingAllowed()) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    if (!configured) { window.gtag('config', measurementId, {send_page_view: false}); configured = true; }
    window.gtag('event', entry.name, Object.assign({send_to: measurementId, transport_type: 'beacon'}, entry.data));
  }
  function emit(name, fields) {
    var data = Object.assign({page_path: window.location.pathname, source_page: window.location.pathname, theme_id: themeId, environment: environment}, fields || {});
    var entry = {name: name, data: data, at: Date.now()};
    queue.push(entry);
    if (queue.length > 100) queue.shift();
    document.dispatchEvent(new CustomEvent('binam:event', {detail: entry}));
    if (environment !== 'live') return;
    send(entry);
  }
  window.BinamSales = {emit: emit, events: queue, environment: environment};
  document.dispatchEvent(new CustomEvent('binam:ready'));
  if (environment === 'live' && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function (error) { var buffered=pending; pending=[]; if(!error)buffered.forEach(send); });
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a');
    if (!link) return;
    var article = link.closest('.article-template, [data-binam-sales]');
    if (article) {
      var target = new URL(link.href, window.location.origin);
      if (target.origin !== window.location.origin) return;
      var block = link.closest('[data-binam-sales]');
      var card = link.closest('[data-product-id]');
      var fields = {article_id: block ? block.dataset.articleId : '', target_page: target.pathname, product_id: card ? card.dataset.productId : '', placement: block ? 'article_top' : 'article_body'};
      if (target.pathname.indexOf('/products/') === 0) emit('article_product_click', fields);
      else if (target.pathname.indexOf('/pages/catalog-') === 0 || target.pathname.indexOf('/collections/') === 0) emit('article_catalog_click', fields);
    }
    var tag = link.closest('.ctc-tag, .binam-brand-pages a');
    if (tag) emit('chain_brand_click', {brand: tag.textContent.trim().slice(0,80)});
    var calculator = link.closest('[data-binam-calculator]');
    if (calculator && /\/(products|collections)\//.test(link.pathname)) emit('calculator_product_click', {calculator_type: calculator.dataset.binamCalculator, target_page: link.pathname});
  });
  var timer;
  document.addEventListener('input', function(event) {
    var search = event.target.closest('input[id^="ctc-search-"],input[id^="wtc-search-"]');
    if (!search) return;
    clearTimeout(timer);
    timer = setTimeout(function() {
      emit('catalog_filter_use', {filter_type: 'search', query_length: search.value.length, catalog_type: search.id.indexOf('ctc-') === 0 ? 'chainsaw_chain' : 'zip_ties'});
    }, 450);
  });
  document.addEventListener('change', function(event) {
    var cb = event.target.closest('.wtc-filter-cb');
    if (cb) emit('catalog_filter_use', {filter_type: cb.dataset.type, filter_value: cb.value, selected: cb.checked, catalog_type: 'zip_ties'});
  });
  document.addEventListener('submit', function(event) {
    var form = event.target.closest('.binam-sales__form, .bsc-order');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled || !form.reportValidity()) return;
    var error = form.querySelector('[role="alert"]');
    var id = new FormData(form).get('id');
    var quantity = Number(new FormData(form).get('quantity') || 1);
    if (!/^\d+$/.test(String(id)) || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 999) { if(error) error.hidden = false; return; }
    button.disabled = true;
    if(error) error.hidden = true;
    fetch(cartUrl, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id: Number(id), quantity: quantity}]})})
      .then(function(response) { if (!response.ok) throw new Error('Cart rejected'); return response.json(); })
      .then(function() {
        var block = form.closest('[data-binam-sales]');
        var catalog = form.closest('.bsc');
        emit(block ? 'article_add_to_cart' : 'catalog_add_to_cart', {article_id: block ? block.dataset.articleId : '', product_id: form.closest('[data-product-id]').dataset.productId, variant_id: String(id), quantity: quantity, catalog_type: catalog ? catalog.dataset.mode : '', placement: block ? 'article_top' : 'catalog_table'});
        window.location.assign(cartPage);
      })
      .catch(function() { if(error) error.hidden = false; button.disabled = false; });
  });
})();

